import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollTop", "scrollTopContent", "scrollBottom", "stickyHeader", "table"]

  connect() {
    this.syncFromTop = () => this.syncHorizontal(this.scrollTopTarget.scrollLeft)
    this.syncFromBottom = () => this.syncHorizontal(this.scrollBottomTarget.scrollLeft)
    this.resize = () => this.refresh()
    this.onWindowScroll = () => this.updateStickyVisibility()

    this.buildStickyHeader()
    this.refresh()

    this.scrollTopTarget.addEventListener("scroll", this.syncFromTop)
    this.scrollBottomTarget.addEventListener("scroll", this.syncFromBottom)
    window.addEventListener("resize", this.resize)
    window.addEventListener("scroll", this.onWindowScroll, { passive: true })

    this.resizeObserver = new ResizeObserver(() => this.refresh())
    this.resizeObserver.observe(this.tableTarget)
  }

  disconnect() {
    this.scrollTopTarget.removeEventListener("scroll", this.syncFromTop)
    this.scrollBottomTarget.removeEventListener("scroll", this.syncFromBottom)
    window.removeEventListener("resize", this.resize)
    window.removeEventListener("scroll", this.onWindowScroll)
    this.resizeObserver?.disconnect()
  }

  buildStickyHeader() {
    const thead = this.tableTarget.querySelector("thead")
    const table = document.createElement("table")
    table.className = this.tableTarget.className
    table.appendChild(thead.cloneNode(true))

    this.stickyHeaderTarget.replaceChildren(table)
    this.stickyHeaderTable = table
  }

  refresh() {
    const totalWidth = this.matchHeaderWidths()
    this.scrollTopContentTarget.style.width = `${this.tableTarget.scrollWidth}px`
    this.scrollTopContentTarget.style.height = "1px"
    this.stickyHeaderTable.style.width = `${totalWidth}px`
    this.element.style.setProperty("--sticky-scroll-top-height", `${this.scrollTopTarget.offsetHeight}px`)
    this.syncHorizontal(this.scrollBottomTarget.scrollLeft)
    this.updateStickyVisibility()
  }

  matchHeaderWidths() {
    const sourceCells = Array.from(this.tableTarget.querySelectorAll("thead th"))
    const stickyCells = Array.from(this.stickyHeaderTable.querySelectorAll("th"))
    let totalWidth = 0

    sourceCells.forEach((cell, index) => {
      const widthValue = cell.getBoundingClientRect().width
      const width = `${widthValue}px`
      stickyCells[index].style.width = width
      stickyCells[index].style.minWidth = width
      stickyCells[index].style.maxWidth = width
      totalWidth += widthValue
    })

    return totalWidth
  }

  syncHorizontal(scrollLeft) {
    if (this.scrollTopTarget.scrollLeft !== scrollLeft) this.scrollTopTarget.scrollLeft = scrollLeft
    if (this.scrollBottomTarget.scrollLeft !== scrollLeft) this.scrollBottomTarget.scrollLeft = scrollLeft
    this.stickyHeaderTarget.scrollLeft = scrollLeft
  }

  updateStickyVisibility() {
    const tableTop = this.scrollBottomTarget.getBoundingClientRect().top
    const stickyThreshold = this.scrollTopTarget.offsetHeight
    this.element.classList.toggle("sticky-header-active", tableTop <= stickyThreshold)
  }
}
